import {WizardComponentController} from "../WizardComponent";
import {IAttributes, IRootElementService, IScope} from "angular";
import {WizardFooterController} from "../footer/WizardFooter";

export const WizardComplete = "wizardComplete";

export function wizardComplete() {
    return {
        restrict: "A",
        require: ["^^tfWizard", "?^^tfWizardFooter"],
        link: ($scope: IScope,
               $elem: IRootElementService,
               $attr: IAttributes,
               wizards: [WizardComponentController, WizardFooterController | null]) => {

            const wizard = wizards[0];
            $elem.on("click", () => {
                const result = $scope.$eval("wizardComplete");
                wizard.complete(result);
            });

            const footer = wizards[1];
            // Only do the automatic show/hide if we're in the footer
            if (footer != null) {
                const stepSub = wizard.stepChanges()
                                      .subscribe(step => {
                                          if (step.last) {
                                              $elem.css("display", "initial");
                                          } else {
                                              $elem.css("display", "none");
                                          }
                                      });
                $scope.$on("$destroy", () => stepSub.unsubscribe());
            }
        }
    };
}
